import { useState, useEffect } from 'react';
import axios from 'axios';
import './UserSessions.css';
import { Header } from 'components/Header/Header';
import { newServer } from '../../constants/constants';

const UserSessions = () => {
  const [sessions, setSessions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalSessions, setTotalSessions] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [limit, setLimit] = useState(10);

  const fetchSessions = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${newServer}audit-trail/get-sessions`, {
        data: {
          query: {
            search,
            from_date: fromDate,
            to_date: toDate,
            page: currentPage,
            limit,
          },
        },
      });

      const data = response.data as { sessions: any[]; totalSessions: number };
      setSessions(data.sessions);
      setTotalSessions(data.totalSessions);
      setTotalSessions((response.data as { totalSessions: number }).totalSessions);
    } catch (error) {
      console.error('Error fetching sessions:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSessions();
  }, [currentPage, limit]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchSessions();
  };

  const formatDate = (date: string | number | Date) => {
    return new Date(date).toLocaleString();
  };

  const totalPages = Math.ceil(totalSessions / limit);

  return (
    <div className='bg-[#111827]'>
      <Header />
      <div className='sessions-container max-w-7xl mx-auto mt 2'>
        <h2>User Sessions</h2>

        <div className='filters-container'>
          <div className='search-section'>
            <input
              type='text'
              placeholder='Search...'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className='search-input'
            />
          </div>

          <div className='date-filters'>
            <input
              type='date'
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className='date-input'
            />
            <input
              type='date'
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className='date-input'
            />
            <button onClick={handleSearch} className='search-button'>
              Search
            </button>
          </div>
        </div>

        <div className='table-container'>
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Browser</th>
                <th>IP Address</th>
                <th>Location</th>
                <th>Session Start</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className='text-center'>
                    Loading...
                  </td>
                </tr>
              ) : sessions.length === 0 ? (
                <tr>
                  <td colSpan={6} className='text-center'>
                    No sessions found
                  </td>
                </tr>
              ) : (
                sessions.map((session) => (
                  <tr key={session.id}>
                    <td>
                      {
                        session.first_name && session.last_name
                          ? `${session.first_name} ${session.last_name}` // Mostrar first_name y last_name
                          : session.user_email
                          ? session.user_email // Mostrar user_email si no hay nombres
                          : 'N/A' // Mostrar N/A si no hay nada disponible
                      }
                    </td>
                    <td>{session.browser || 'N/A'}</td>
                    <td>{session.ip_address || 'N/A'}</td>
                    <td>{session.location || 'N/A'}</td>
                    <td>{formatDate(session.session_start)}</td>
                    <td>{formatDate(session.date_updated)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className='pagination-container'>
          <div className='items-per-page'>
            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
              className='limit-select'
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
            </select>
            <span className='items-info'>
              Showing {sessions.length} of {totalSessions} sessions
            </span>
          </div>

          <div className='pagination-controls'>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className='pagination-button'
            >
              Previous
            </button>
            <span className='page-info'>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className='pagination-button'
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSessions;
